import type { Lang } from '@/data/categories';
import { homeContent } from '@/data/home';

export default function TrustSections({ lang }: { lang: Lang }) {
  const c = homeContent[lang];

  return (
    <>
      {/* Comparison */}
      <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <h2 className="text-center text-2xl font-bold text-foreground-950 md:text-3xl">{c.comparison.h2}</h2>
        <div className="mt-8 overflow-x-auto rounded-lg border border-background-200 bg-background-50">
          <table className="w-full min-w-[560px] text-left text-sm">
            <thead>
              <tr className="border-b border-background-200 bg-background-100">
                {c.comparison.columns.map((col, i) => (
                  <th key={i} className="px-5 py-3.5 font-semibold text-foreground-900">{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {c.comparison.rows.map((row, i) => (
                <tr key={i} className="border-b border-background-100 last:border-0">
                  <td className="px-5 py-3 font-medium text-foreground-800">{row[0]}</td>
                  <td className="px-5 py-3 text-foreground-600">{row[1]}</td>
                  <td className="px-5 py-3 text-foreground-600">{row[2]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Safety */}
      <section className="bg-secondary-100">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">{c.safety.h2}</h2>
              <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
                {c.safety.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-2.5 rounded-lg bg-background-50 p-3">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                      <i className="ri-shield-check-line text-sm"></i>
                    </span>
                    <span className="text-sm text-foreground-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex flex-col justify-center rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                <i className="ri-information-line text-2xl"></i>
              </span>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">{c.safety.disclaimer}</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}